/**
 * @module
 */

import {CONNECT, DESTROY} from '@acng/frontend-stargazer';
import {isMobile} from './service/env.js';
import {goBack} from './service/location.js';
import {ClickEventController} from 'nova';
import {connect, disconnect} from 'acng/layout/service/size.js';

export const navigator = {
  desktop: !isMobile,
  mobile: isMobile,
  back: new ClickEventController(() => goBack()),
  class: {
    width: {
      [CONNECT]: connect,
      [DESTROY]: disconnect
    }
  },
};
